import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { useSplitEnabled } from '@bufferapp/features';

import { GenerateIdeasButton } from '~/ai/components';
import Button from '@bufferapp/ui/Button';
import InstagramCommentIcon from '@bufferapp/ui/Icon/Icons/InstagramComment';
import { HeaderStyled, TitleStyled } from './styles';

const Header = (): JSX.Element => {
  const { t } = useTranslation();

  const { isEnabled: isContentIdeationEnabled } = useSplitEnabled(
    'LABSNPI-content-ideation'
  );

  return (
    <HeaderStyled>
      <TitleStyled type="h2">{t('content.common.title')}</TitleStyled>
      <Button
        id="ideas_share_feedback"
        type="text"
        icon={<InstagramCommentIcon />}
        label="Share Feedback"
      />
      {isContentIdeationEnabled && <GenerateIdeasButton />}
      <Dialog.Trigger asChild>
        <Button
          onClick={() => ({})}
          type="primary"
          label={t('content.common.createIdea')}
        />
      </Dialog.Trigger>
    </HeaderStyled>
  );
};

export default Header;
